/* Gemensam bildväljare. Förbättrar befintliga kontroller, skickar aldrig köp.
   Ursprungliga id, name, values, antal och packlistor förblir källan. */
(function () {
  'use strict';
  if (window.vkPatternPicker) return;
  if (!document.querySelector || !window.addEventListener) return;
  var translations = {
    nb: ['Endre mønster', 'Forstørr', 'Lukk', 'Ferdig', 'Duksett', 'Bivoksrull', 'Valgt', 'Velg mønster', 'Utsolgt', 'Forrige mønster', 'Neste mønster', 'Velg', 'Bivoksposer'],
    sv: ['Ändra mönster', 'Förstora', 'Stäng', 'Klart', 'Dukset', 'Bivaxrulle', 'Valt', 'Välj mönster', 'Slutsålt', 'Föregående mönster', 'Nästa mönster', 'Välj', 'Bivaxpåsar'],
    da: ['Skift mønster', 'Forstør', 'Luk', 'Færdig', 'Sæt med bivokspapir', 'Bivoksrulle', 'Valgt', 'Vælg mønster', 'Udsolgt', 'Forrige mønster', 'Næste mønster', 'Vælg', 'Bivoksposer'],
    en: ['Change pattern', 'Enlarge', 'Close', 'Done', 'Wrap set', 'Beeswax roll', 'Selected', 'Choose a pattern', 'Sold out', 'Previous pattern', 'Next pattern', 'Choose', 'Beeswax pouches'],
    de: ['Muster ändern', 'Vergrößern', 'Schließen', 'Fertig', 'Wachstuch-Set', 'Bienenwachsrolle', 'Ausgewählt', 'Muster wählen', 'Ausverkauft', 'Vorheriges Muster', 'Nächstes Muster', 'wählen', 'Bienenwachsbeutel'],
    fr: ['Changer le motif', 'Agrandir', 'Fermer', 'Terminé', 'Lot de tissus cirés', 'Rouleau de tissu ciré', 'Sélectionné', 'Choisir un motif', 'Épuisé', 'Motif précédent', 'Motif suivant', 'Choisir', 'Pochettes en cire d’abeille'],
    nl: ['Patroon wijzigen', 'Vergroten', 'Sluiten', 'Klaar', 'Set bijenwasdoeken', 'Bijenwasrol', 'Gekozen', 'Kies een patroon', 'Uitverkocht', 'Vorig patroon', 'Volgend patroon', 'Kies', 'Bijenwaszakjes']
  };
  var lang = (document.documentElement.lang || 'nb').split('-')[0];
  var words = translations[lang];
  if (!words) return;
  var config, main, groups = [], multis = [], serial = 0, timer, modal, returnFocus, priorOverflow;
  function all(root, selector) { return Array.prototype.slice.call(root.querySelectorAll(selector)); }
  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }
  function button(className, text) { var b = el('button', className, text); b.type = 'button'; return b; }
  function picture(src, className) {
    var img = el('img', className); img.alt = ''; img.width = 96; img.height = 96;
    img.loading = 'lazy'; img.src = sizedSource(src, 320); return img;
  }
  function change(select, value) {
    select.value = value;
    var event;
    try { event = new Event('change', { bubbles: true }); }
    catch (err) { event = document.createEvent('Event'); event.initEvent('change', true, false); }
    select.dispatchEvent(event);
  }
  function lookup(value, name, roll) {
    var list = roll ? config.rolls : config.wraps;
    for (var i = 0; i < list.length; i++) if (list[i].id === value || list[i].name === name || list[i].name === value) return list[i];
    return null;
  }
  function imageSource(node) {
    var img = node.querySelector('img'); return img && (img.currentSrc || img.src) || '';
  }
  function nameFor(node) {
    var input = node.querySelector('input');
    return input && (input.getAttribute('data-pattern-name') || input.value) || node.getAttribute('data-name') || node.getAttribute('title') || node.getAttribute('aria-label') || node.textContent.trim();
  }
  function isSelected(node) {
    var input = node.querySelector('input');
    return input ? input.checked : node.classList.contains('is-active') || node.getAttribute('aria-pressed') === 'true' || node.getAttribute('aria-current') === 'true';
  }
  function sizedSource(src, width) {
    try { var url = new URL(src, location.href); url.searchParams.set('width', String(width)); return url.href; }
    catch (err) { return src; }
  }
  var zoomGroup, zoomCards = [], zoomIndex = 0, inertBefore = [];
  function unavailable(card) {
    var input = card.querySelector('input');
    return card.disabled || (input && input.disabled) || card.getAttribute('aria-disabled') === 'true';
  }
  function closeZoom() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.documentElement.style.overflow = priorOverflow || '';
    inertBefore.forEach(function (row) { row.node.inert = row.value; }); inertBefore = [];
    if (returnFocus && document.documentElement.contains(returnFocus)) returnFocus.focus();
  }
  function updateZoom() {
    var card = zoomCards[zoomIndex], pattern = fromCard(card), selected = isSelected(card);
    modal.querySelector('.vk-pattern-zoom__context').textContent = zoomGroup.title;
    modal.querySelector('.vk-pattern-zoom__title').textContent = pattern.name;
    var img = modal.querySelector('img'); img.alt = zoomGroup.title + ': ' + pattern.name;
    img.src = sizedSource(pattern.image, 1400);
    modal.querySelector('.vk-pattern-zoom__position').textContent = (zoomIndex + 1) + ' / ' + zoomCards.length;
    modal.querySelector('.vk-pattern-zoom__previous').disabled = zoomCards.length < 2;
    modal.querySelector('.vk-pattern-zoom__next').disabled = zoomCards.length < 2;
    var choose = modal.querySelector('.vk-pattern-zoom__choose');
    choose.disabled = unavailable(card) || selected;
    var action = lang === 'de' ? pattern.name + ' ' + words[11] : words[11] + ' ' + pattern.name;
    choose.textContent = unavailable(card) ? words[8] : selected ? words[6] + ': ' + pattern.name + ' ✓' : action;
  }
  function moveZoom(direction) {
    zoomIndex = (zoomIndex + direction + zoomCards.length) % zoomCards.length; updateZoom();
  }
  function zoom(group, origin) {
    zoomCards = all(group.grid, '[data-vk-pattern-card]').filter(function (card) { return !!imageSource(card); });
    if (!zoomCards.length) return;
    zoomGroup = group; zoomIndex = 0;
    zoomCards.forEach(function (card, index) { if (isSelected(card)) zoomIndex = index; });
    if (!modal) {
      modal = el('div', 'vk-pattern-zoom vk-pattern-zoom--browse'); modal.hidden = true;
      modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-labelledby', 'vk-pattern-zoom-title'); modal.setAttribute('aria-describedby', 'vk-pattern-zoom-context');
      var sheet = el('div', 'vk-pattern-zoom__sheet');
      var header = el('div', 'vk-pattern-zoom__header');
      var context = el('span', 'vk-pattern-zoom__context'); context.id = 'vk-pattern-zoom-context';
      var close = button('vk-pattern-zoom__close', words[2] + ' ×');
      var title = el('strong', 'vk-pattern-zoom__title'); title.id = 'vk-pattern-zoom-title'; title.setAttribute('aria-live', 'polite');
      var img = el('img', 'vk-pattern-zoom__image'); img.width = 1000; img.height = 1000;
      var nav = el('div', 'vk-pattern-zoom__navigation');
      var previous = button('vk-pattern-zoom__close vk-pattern-zoom__previous', '←'); previous.setAttribute('aria-label', words[9]);
      var position = el('span', 'vk-pattern-zoom__position');
      var next = button('vk-pattern-zoom__close vk-pattern-zoom__next', '→'); next.setAttribute('aria-label', words[10]);
      var choose = button('vk-pattern-zoom__close vk-pattern-zoom__choose');
      previous.addEventListener('click', function () { moveZoom(-1); });
      next.addEventListener('click', function () { moveZoom(1); });
      choose.addEventListener('click', function () {
        var card = zoomCards[zoomIndex]; if (unavailable(card)) return;
        // Det ursprungliga kortet äger variant och packfält. Bläddring ändrar inget.
        card.click(); zoomGroup.update(); zoomGroup.close(false); closeZoom();
      });
      close.addEventListener('click', closeZoom);
      header.appendChild(context); header.appendChild(close);
      nav.appendChild(previous); nav.appendChild(position); nav.appendChild(next);
      sheet.appendChild(header); sheet.appendChild(title); sheet.appendChild(img); sheet.appendChild(nav); sheet.appendChild(choose);
      modal.appendChild(sheet); document.body.appendChild(modal);
      modal.addEventListener('click', function (e) { if (e.target === modal) closeZoom(); });
      modal.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.keyCode === 27) { e.preventDefault(); closeZoom(); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); moveZoom(-1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); moveZoom(1); }
        if (e.key === 'Tab' || e.keyCode === 9) {
          var focusable = all(modal, 'button').filter(function (b) { return !b.disabled; });
          var first = focusable[0], last = focusable[focusable.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });
    }
    returnFocus = origin; priorOverflow = document.documentElement.style.overflow;
    updateZoom(); modal.hidden = false; document.documentElement.style.overflow = 'hidden';
    all(document.body, ':scope > *').forEach(function (node) {
      if (node !== modal && 'inert' in node) { inertBefore.push({ node: node, value: node.inert }); node.inert = true; }
    });
    modal.querySelector('.vk-pattern-zoom__close').focus();
  }
  function updateSoon() { clearTimeout(timer); timer = setTimeout(function () { multis.forEach(function (m) { m.update(); }); groups.forEach(function (g) { g.update(); }); }, 0); }
  function labelFor(select) {
    var label = select.id && all(main, 'label[for]').filter(function (l) { return l.htmlFor === select.id; })[0];
    return label || null;
  }
  function componentTitle(select, index) {
    var roll = (select.name || '').indexOf('_RollPattern') > -1 || (select.id || '').indexOf('native-roll') > -1;
    return (roll ? words[5] : words[4]) + (index ? ' ' + index : '');
  }
  function createGroup(grid, title, read, nodes, select) {
    if (grid.hasAttribute('data-vk-pattern-grid')) return;
    var group = el('div', 'vk-pattern-group'), head = el('div', 'vk-pattern-head');
    var open = button('vk-pattern-open'), thumbs = el('span', 'vk-pattern-chosen-images');
    var copy = el('span', 'vk-pattern-copy'), component = el('span', 'vk-pattern-component', title);
    var names = el('strong', 'vk-pattern-chosen-name'); names.setAttribute('aria-live', 'polite');
    var edit = el('span', 'vk-pattern-edit', words[0]);
    copy.appendChild(component); copy.appendChild(names); copy.appendChild(edit); open.appendChild(thumbs); open.appendChild(copy);
    var preview = button('vk-pattern-enlarge', words[1]);
    var panel = el('div', 'vk-pattern-panel'); panel.id = 'vk-pattern-panel-' + (++serial);
    open.setAttribute('aria-controls', panel.id); open.setAttribute('aria-expanded', 'false');
    var done = button('vk-pattern-done', words[3] + ' ✓');
    head.appendChild(open); head.appendChild(preview); group.appendChild(head); group.appendChild(panel);
    grid.parentNode.insertBefore(group, grid);
    (nodes || []).forEach(function (n) { if (n && n.parentNode) panel.appendChild(n); });
    panel.appendChild(grid); panel.appendChild(done);
    grid.hidden = false; grid.setAttribute('data-vk-pattern-grid', '');
    if (select) { select.setAttribute('data-vk-pattern-native', ''); select.setAttribute('tabindex', '-1'); }
    panel.hidden = true;
    var current = [];
    var g = {
      group: group, grid: grid, title: title, panel: panel, open: open,
      close: function (focus) { panel.hidden = true; open.setAttribute('aria-expanded', 'false'); if (focus) open.focus(); },
      update: function () {
        current = read();
        var text = current.map(function (p) { return p.name; }).join(' · ') || words[7];
        if (names.textContent !== text) {
          names.textContent = text;
          while (thumbs.firstChild) thumbs.removeChild(thumbs.firstChild);
          current.forEach(function (p) { if (p.image) thumbs.appendChild(picture(p.image)); });
        }
        preview.disabled = !current.length || !current[0].image;
        preview.setAttribute('aria-label', words[1] + ': ' + text);
        all(grid, '[data-vk-pattern-card]').forEach(function (card) { card.setAttribute('data-vk-pattern-selected', isSelected(card) ? 'true' : 'false'); });
      }
    };
    open.addEventListener('click', function () {
      var closed = panel.hidden;
      groups.forEach(function (other) { if (other !== g) other.close(false); });
      panel.hidden = !closed; open.setAttribute('aria-expanded', closed ? 'true' : 'false');
      if (closed) g.update();
    });
    done.addEventListener('click', function () { g.close(true); });
    preview.addEventListener('click', function () { zoom(g, preview); });
    panel.addEventListener('keydown', function (e) { if (e.key === 'Escape' || e.keyCode === 27) { e.preventDefault(); g.close(true); } });
    grid.addEventListener('change', function (e) {
      updateSoon();
      if (e.target.tagName === 'INPUT' && e.target.type === 'radio') setTimeout(function () { g.close(true); }, 0);
    });
    grid.addEventListener('click', function (e) {
      var target = e.target.closest && e.target.closest('button[data-vk-catp-value], [data-vk-roll-choice]');
      if (target && !target.disabled) setTimeout(function () { g.update(); g.close(true); }, 0);
    });
    groups.push(g); g.update();
    return g;
  }
  function decorate(grid) {
    var cards = all(grid, 'button[data-vk-catp-value],a[data-vk-roll-choice],label[data-vk-pattern-wrap],label[data-vk-stor-wrap],label[data-vk-w3-wrap]');
    cards.forEach(function (card) {
      if (card.hasAttribute('data-vk-pattern-card')) return;
      var name = nameFor(card), input = card.querySelector('input');
      card.setAttribute('data-vk-pattern-card', '');
      if (input && !input.getAttribute('aria-label')) input.setAttribute('aria-label', name);
      if (!card.querySelector('.vk-new-product__thumb-name,.vk-w3__swatch-label')) card.appendChild(el('span', 'vk-pattern-card-name', name));
      var tick = el('span', 'vk-pattern-tick', '✓'); tick.setAttribute('aria-hidden', 'true'); card.appendChild(tick);
    });
  }
  function fromCard(card) { return { name: nameFor(card), image: imageSource(card) }; }
  function enhanceSelect(select, existing, title) {
    if (select.hasAttribute('data-vk-pattern-native')) return;
    var grid = existing || el('div', 'vk-pattern-generated-grid'), roll = (select.name || '').indexOf('_RollPattern') > -1;
    var label = labelFor(select), data = [];
    if (!existing) {
      all(select, 'option').forEach(function (opt) {
        var match = lookup(opt.value, opt.textContent, roll);
        var source = opt.getAttribute('data-vk-w3-img') || match && match.image;
        if (!source) return;
        var b = button('vk-catp-thumb'); b.setAttribute('data-vk-catp-value', opt.value); b.setAttribute('title', opt.textContent); b.setAttribute('aria-label', opt.textContent); b.setAttribute('aria-pressed', 'false');
        b.disabled = opt.disabled || opt.getAttribute('data-available') === 'false';
        b.appendChild(picture(source, 'vk-pattern-generated-image'));
        if (b.disabled) b.appendChild(el('span', 'vk-pattern-soldout', words[8]));
        b.addEventListener('click', function () { if (!b.disabled) change(select, opt.value); });
        grid.appendChild(b);
      });
      if (grid.children.length !== select.options.length) return; // komplett reservlista vid saknad bild
      select.parentNode.insertBefore(grid, select);
    }
    all(grid, '[data-vk-catp-value]').forEach(function (card) { data.push({ value: card.getAttribute('data-vk-catp-value'), card: card }); });
    decorate(grid);
    var g = createGroup(grid, title, function () {
      var picked = [];
      data.forEach(function (d) {
        var active = d.value === select.value;
        d.card.classList.toggle('is-active', active); d.card.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (active) picked.push(fromCard(d.card));
      });
      return picked;
    }, [label, select], select);
    if (label) label.setAttribute('data-vk-pattern-old-label', '');
    var stack = g && g.group.parentNode;
    if (stack && stack.classList.contains('vk-catalog-product__pattern-grid')) stack.setAttribute('data-vk-pattern-stack', '');
  }
  function enhanceRadioGrid(grid, title) {
    if (grid.hasAttribute('data-vk-pattern-grid')) return;
    decorate(grid);
    var group = createGroup(grid, title, function () {
      return all(grid, '[data-vk-pattern-card]').filter(isSelected).map(fromCard);
    });
    var root = grid.closest('[data-vk-wpdp],[data-vk-kpdp],#vk-storfamilie');
    if (root) enhanceMultiple(grid, group, root);
  }
  function enhanceMultiple(original, single, root) {
    var stor = root.id === 'vk-storfamilie';
    var sourceCards = all(original, '[data-vk-pattern-card]'), slots = [];
    var singleChoice = original.querySelector('input[type="radio"]:checked');
    original.addEventListener('change', function (e) { if (e.target.type === 'radio') singleChoice = e.target; });
    root.addEventListener('click', function (e) {
      var rung = e.target.closest && e.target.closest('[data-vk-kpdp-rung="1"]');
      if (!rung || !singleChoice) return;
      // Den äldre mallen byter checkboxar till radio en i taget. Ett senare
      // förvalt mönster kan då avmarkera det återställda förstavalet.
      setTimeout(function () {
        if (singleChoice.type === 'radio' && !singleChoice.checked) { singleChoice.checked = true; change(singleChoice, singleChoice.value); }
      }, 0);
    });
    function fields() {
      if (!stor && original.querySelector('input').type !== 'checkbox') return [];
      return all(root, '[data-vk-wpdp-m],[data-vk-kpdp-m],[data-vk-stor-m]').filter(function (h) { return !h.closest('form').hidden; });
    }
    for (var i = 0; i < 3; i++) (function (index) {
      var grid = el('div', 'vk-pattern-generated-grid');
      single.group.parentNode.insertBefore(grid, single.group);
      sourceCards.forEach(function (card) {
        var input = card.querySelector('input'), name = nameFor(card);
        var b = button('vk-catp-thumb'); b.setAttribute('data-vk-catp-value', name); b.setAttribute('title', name); b.setAttribute('aria-label', name);
        b.disabled = input.disabled; b.appendChild(picture(imageSource(card)));
        b.addEventListener('click', function () {
          var active = fields(), desired = active.map(function (h) { return h.value; });
          if (!active[index]) return;
          desired[index] = name;
          // Spela samma slutliga ordning genom de befintliga lyssnarna. De äger
          // variant, dubbletter och packlista; endast den redigerade platsen byts.
          desired.forEach(function (pattern) {
            var c = sourceCards.filter(function (item) { return nameFor(item) === pattern; })[0];
            if (c) { var originalInput = c.querySelector('input'); originalInput.checked = true; change(originalInput, originalInput.value); }
          });
          updateSoon();
        });
        grid.appendChild(b);
      });
      decorate(grid);
      var g = createGroup(grid, words[4] + ' ' + (index + 1), function () {
        var h = fields()[index], name = h && h.value, picked = [];
        all(grid, '[data-vk-pattern-card]').forEach(function (card) {
          var active = card.getAttribute('data-vk-catp-value') === name;
          card.classList.toggle('is-active', active); card.setAttribute('aria-pressed', active ? 'true' : 'false');
          if (active) picked.push(fromCard(card));
        });
        return picked;
      });
      slots.push(g);
    })(i);
    var multi = { update: function () {
      var active = fields(); single.group.hidden = active.length > 1;
      slots.forEach(function (g, index) { g.group.hidden = active.length < 2 || index >= active.length; });
    } };
    multis.push(multi); multi.update();
  }
  function boot() {
    var source = document.getElementById('vk-pattern-config');
    main = document.querySelector('main');
    if (!source || !main) return;
    try { config = JSON.parse(source.textContent); } catch (err) { return; }
    all(main, '[data-vk-catp-for]').forEach(function (grid) {
      var select = document.getElementById(grid.getAttribute('data-vk-catp-for'));
      if (!select) return;
      var index = (select.id.match(/(?:pattern|wrap|roll)-(\d+)/) || [])[1];
      enhanceSelect(select, grid, componentTitle(select, index));
    });
    all(main, 'select[data-vk-w3-select]').forEach(function (s) { enhanceSelect(s, null, words[4] + ' ' + s.getAttribute('data-vk-w3-select')); });
    if (config.handle === 'pakke-blokk-bivokspapir' || config.handle === 'pakke-brodpose-blokk-bivokspapir' || config.handle === 'julepakken') {
      all(main, 'select[data-vk-catalog-variant]').forEach(function (s) { enhanceSelect(s, null, words[4]); });
    }
    all(main, 'select[data-vk-addon-pattern]').forEach(function (s) { enhanceSelect(s, null, words[4]); });
    all(main, '.vk-wpdp__thumbs,.vk-kpdp__thumbs,.vk-bundle__pthumbs,.vk-w3__swatches,.vk-new-product__variants').forEach(function (grid) {
      if (grid.classList.contains('vk-new-product__variants') && !grid.querySelector('[data-vk-roll-choice]')) return;
    var slot = grid.closest('[data-vk-w3-slot]');
    var kind = grid.getAttribute('data-vk-pattern-kind');
    enhanceRadioGrid(grid, kind === 'pose' ? words[12] : grid.querySelector('[data-vk-roll-choice]') ? words[5] : words[4] + (slot ? ' ' + slot.getAttribute('data-vk-w3-slot') : ''));
    });
    if (groups.length) main.setAttribute('data-vk-pattern-ready', '');
    updateSoon();
  }
  window.vkPatternPicker = { init: boot };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('change', updateSoon);
  document.addEventListener('click', updateSoon);
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('pageshow', updateSoon);
})();
